import { getTCStringFromCookie } from '@module/consent-manager/cookieutils';

export default {
  tcString: getTCStringFromCookie(),
  uiVisible: false,
};
